/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext } from 'react';
import { NavLink } from 'react-router-dom'
import { authContext } from '../../store/AuthContext';

const Navbar = () => {

    const authCtx = useContext(authContext);

    return (
        <div className='container-fluid' >
            <div className='row'>
                <nav className="navbar navbar-expand-sm">
                    <div className='container'>
                        <ul className="navbar-nav align-items-center">
                            {
                                authCtx.adminType !== 'lead' && <li><NavLink className='nav-item' activeClassName='nav-link nav-item-selected' to='/sites' >Sites</NavLink></li>
                            }
                            {
                                authCtx.adminType !== 'lead' && <li><NavLink className='nav-item' activeClassName='nav-link nav-item-selected' to='/images' >Gallery/Images</NavLink></li>
                            }
                            {
                                authCtx.adminType !== 'lead' && <li><NavLink className='nav-item' activeClassName='nav-link nav-item-selected' to='/amenities' >Amenities</NavLink></li>
                            }
                            {
                                authCtx.adminType !== 'lead' && <li><NavLink className='nav-item' activeClassName='nav-link nav-item-selected' to='/units' >Property Units</NavLink></li>
                            }
                            {
                                authCtx.adminType !== 'lead' && <li><NavLink className='nav-item' activeClassName='nav-link nav-item-selected' to='/floor-plans' >Floor Plans</NavLink></li>
                            }
                            {
                                <li><NavLink className='nav-item' activeClassName='nav-link nav-item-selected' to='/form' >Form</NavLink></li>
                            }
                            {
                                authCtx.adminType !== 'lead' && authCtx.adminType !== 'data' && <li><NavLink className='nav-item' activeClassName='nav-link nav-item-selected' to='/users' >Users</NavLink></li>
                            }
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    )

}

export default Navbar;